// Products Getters

export const getProductsList = state => {
  return state.productsList
}

export const getProductInfo = state => {
  return state.productInfo
}

export const getFullSaleProductsList = state => {
  return state.fullSaleProductsList
}

export const getFullPurchaseProductsList = state => {
  return state.fullPurchaseProductsList
}

export const getFullProductsList = state => {
  return state.fullProductsList
}
